export default __webpack_public_path__ + "media/images/mailer/icon_done-06ba9b5d6930e264a34fb746f83d5446.png";